import { render } from "./VocabularyDetails.vue?vue&type=template&id=4b3b27fc&scoped=true&ts=true"
import script from "./VocabularyDetails.vue?vue&type=script&lang=ts"
export * from "./VocabularyDetails.vue?vue&type=script&lang=ts"

import "./VocabularyDetails.vue?vue&type=style&index=0&id=4b3b27fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3b27fc"]])

export default __exports__